import React, { Fragment } from "react";
import { Button, Image, View, StyleSheet, Text, TouchableOpacity, Platform } from "react-native";
import InputContainer from "../Layout/InputContainer";
import PropTypes from "prop-types";
import Style from "ae-style";
import SignaturePopup from "ae-base/Base/SignaturePopup";

const styles = StyleSheet.create({
	containerComponent: {
		borderBottomWidth: 2,
		borderColor: "black",
		borderStyle: "solid",
		flexDirection: "row",
		maxHeight: 150,
		minHeight: 100,
		width: "100%"
	},
	containerFrame: {
		borderColor: "black",
		borderStyle: "solid",
		borderWidth: 2,
		padding: 8
	},
	contrastBorder: {
		borderColor: Style.look.contrast.text
	},
	rightAligned: {
		alignSelf: "flex-end",
		maxWidth: 500,
		width: "100%"
	},
	x: {
		alignSelf: "flex-end",
		fontWeight: "bold",
		textAlignVertical: "bottom"
	},
	xContrast: {
		color: Style.look.contrast.text
	}
});

const IS_WEB = Platform.OS === "web";
export default class SignatureInline extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			signaturePreview: ""
		};
	}

	render() {
		const props = this.props;
		const schema = props.schema;
		const errors = props.errors;
		const contrast = props.contrast;

		let previewUri = this.state.signaturePreview;
		if (props.defaultValue) {
			if (props.defaultValue.url) {
				//default previously uploaded image
				previewUri = props.defaultValue.url;
			}
			else if (props.defaultValue.uri) {
				//mobile preview
				previewUri = props.defaultValue.uri;
			}
		}

		const ContainerComponent = props.displayMode ? View : TouchableOpacity;

		const containerFrameStyles = [styles.containerFrame, styles.rightAligned];
		const containerComponentStyles = [styles.containerComponent];
		const xStyles = [styles.x];
		if (contrast) {
			if (IS_WEB) {
				//tint color not implemented in our version of RN-WEB yet
				containerFrameStyles.push({ filter: "invert(1)" });
			} else {
				containerComponentStyles.push(styles.contrastBorder);
				containerFrameStyles.push(styles.contrastBorder);
				xStyles.push(styles.xContrast);
			}
		}


		if (errors && errors.length) {
			containerFrameStyles.push({ borderColor: Style.look.alert, backgroundColor: Style.look.alertBackground });
		}

		return <InputContainer>
			{schema && <InputLabel schema={schema} ignoreObjectStyle contrast={props.contrast} />}
			<View style={styles.rightAligned}>
				<ErrorMessage id={this.props.id + "_error"} errors={errors} schema={schema} />
			</View>
			<View style={containerFrameStyles}>
				<SignaturePopup
					openComponent={(onOpen) => {
						return <ContainerComponent onPress={onOpen} style={containerComponentStyles}>
							<Text style={xStyles}>X</Text>
							<Image source={previewUri ? { uri: previewUri } : undefined} style={{ flexGrow: 1 }} resizeMode="contain" tintColor={props.contrast ? "white" : undefined}></Image>
						</ContainerComponent>;
					}}
					onDone={(file, base64) => {
						this.props.onChange(file);
						this.setState({ signaturePreview: base64 });
					}}
					isATouchAway={props.isATouchAway}
				/>
			</View>
		</InputContainer>;
	}
}



import types from "../Layout/inputTypes";
import MobileLandscape from "./MobileLandscape/index.ios";
import InputLabel from "../Layout/InputLabel";
import ErrorMessage from "../Layout/ErrorMessage";

SignatureInline.propTypes = types;